module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2p"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('a', {
    attrs: {
      "id": "pre"
    }
  }), _vm._v("PREFACE")]), _vm._v(" "), _c('p', {
    staticClass: "imagep"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "blockp"
  }, [_c('em', [_vm._v("I’m often asked to describe what happened during the months I spent researching these issues. They want to know what facts were so persuasive that an atheist attorney would become a believer in God. But I never felt I could respond in a way that told the true story. No short answer seemed sufficient. So now, in the following pages, I’ll describe for the first time the specifics of what jolted me out of my atheism")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "rightp"
  }, [_vm._v("—M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHAEL")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INOT")]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc5c2a04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 78
// module chunks = 0